export default "<div class=\"progress\">\r\n  <div class=\"progress__bar\" [ngStyle]=\"{'width': index + '%'}\"></div>\r\n</div>\r\n";